// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZXJZ","rootMobile":"styles_rootMobile__1ibNJ"};